import { Box } from '@mui/material';
import { useAppNavigate } from '../../../../Hooks/back/useAppNavigate';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { CommonActions } from '../../../../Reducer/CommonReducer';
import WeeklyCalendar from '../../M_PER_CUSTOM/ui/WeekCalendar';
import PermitList from '../../M_PER_CUSTOM/ui/PermitList';
import FilterBottomSheet from '../../ui/FilterBottomSheet';
import WriteFAB from '../../ui/WriteFAB';

export default function M_PER_BASIC(props) {
  const { navigate } = useAppNavigate();
  const dispatch = useDispatch();
  const bottomSheetState = useSelector((state) => state.bottomSheet);
  const { selectedFilter } = useSelector((state) => state.permit);
  const searchRef = props.searchRef;

  const handleDateSelect = (date) => {
    searchRef.current.workDate = date.format('YYYY-MM-DD');
    props.SearchLogic1(props.userInfo);
  };

  const filteredPermits = props.rowData1?.filter((item) => {
    const isSameDate =
      dayjs(item.WORK_START_DATE).format('YYYY-MM-DD') ===
      dayjs(searchRef.current.workDate).format('YYYY-MM-DD');
    const isStatusMatch =
      selectedFilter === '전체' || item.GUBUN === selectedFilter;
    return isSameDate && isStatusMatch;
  });

  const handleWriteClick = () => {
    // 스택형 뒤로가기로 변경: write 첫 렌더 전에 step을 먼저 맞춰 즉시 list로 되돌아가는 문제 방지
    dispatch(CommonActions.setActiveStep(1));
    navigate('/M_Permit/write');
  };

  return (
    <>
      <Box
        sx={{
          px: 2,
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
          fontSize: '16px',
        }}
      >
        {/* 주간 캘린더 */}
        <WeeklyCalendar
          onDateSelect={handleDateSelect}
          refreshClick={props.refreshClick}
        />
        {/* 작업허가서 목록 */}
        <PermitList
          data={filteredPermits}
          setExtendData={props.setExtendData}
          extendData={props.extendData}
          SaveLogic1={props.SaveLogic1}
          handleExtendConfirm={props.handleExtendConfirm}
          ToggleDrawer={props.ToggleDrawer}
        />

        {/* 바텀시트 부분 */}
        {bottomSheetState.bottom && bottomSheetState.type === 'filter' && (
          <FilterBottomSheet SearchLogic1={props.SearchLogic1} />
        )}
        {props.userInfo.authCd === 'HEAD_MANAGER' ? (
          <></>
        ) : (
          <WriteFAB handleWriteClick={handleWriteClick} />
        )}
      </Box>
    </>
  );
}
